import { createGlobalStyle } from 'styled-components';

const TippyTooltipStyleOverride = createGlobalStyle`
                                  .tippy-tooltip {
                                    border-radius: var(--border-radius) !important;
                                  }`;

export default TippyTooltipStyleOverride;
